import { getOffsetTop } from './get-offset-top';

interface ParallaxPropsInterface {
  speed?: number;
  offset?: number;
  horizontalPositionPerc?: number;
  parallaxHeightPerc?: number;
  supportsWebp?: boolean;
}

export default class Parallax implements ParallaxPropsInterface {
  speed = 1.5;
  offset = 0;
  horizontalPositionPerc = 50;
  parallaxHeightPerc = 180;
  supportsWebp = false;
  private ticking = false;
  private lastScrollY = 0;
  private readonly wrapper: HTMLElement | null;
  private readonly background: HTMLElement | null;

  constructor(element: HTMLElement, props?: ParallaxPropsInterface) {
    this.wrapper = element;
    if (props) {
      Object.assign(this, props);
    }

    this.background = this.createBackgroundElement();
    this.wrapper.prepend(this.background);
    this.wrapper.style.position = 'relative';
    this.wrapper.style.overflow = 'hidden';

    window.addEventListener('scroll', (e) => this.parallaxHandler(e), false);
    window.addEventListener('resize', (e) => this.parallaxHandler(e), false);
    this.parallaxHandler();
  }

  private createBackgroundElement(): HTMLElement {
    const background = document.createElement('div');
    background.classList.add('parallax-background');

    if (this.wrapper) {
      let imageSrc = this.wrapper.getAttribute('data-image-src');
      if (this.supportsWebp) {
        const webpSrc = this.wrapper.getAttribute('data-image-src-webp');
        if (webpSrc) {
          imageSrc = webpSrc;
        }
      }

      background.style.backgroundImage = `url("${imageSrc}")`;
      background.style.backgroundSize = 'cover';
      background.style.position = 'absolute';
      background.style.top = '0';
      background.style.left = '0';
      background.style.width = '100%';
      background.style.height = `${this.parallaxHeightPerc}%`;
    }

    return background;
  }

  private parallaxHandler(_e?: Event): void {
    const _this = this;
    this.lastScrollY = window.scrollY;
    const lastScrollY = this.lastScrollY;

    if (!this.ticking) {
      window.requestAnimationFrame(function () {
        if (_this.wrapper && _this.background) {
          const offset = getOffsetTop(_this.wrapper);
          const yPos = -(lastScrollY - (offset - 100)) / ((_this.speed + 2));
          const plxPos = (yPos < 0) ? Math.abs(yPos) : -Math.abs(yPos);
          const translatePosition = Math.round((plxPos - 50) + (_this.offset));
          _this.background.style.transform = `translate3d(0, ${translatePosition}px, 0)`;
          _this.background.style.backgroundPositionX = `${_this.horizontalPositionPerc}%`;
        }

        _this.ticking = false;
      });

      this.ticking = true;
    }
  }
}
